<template>
<!-- 搜索框组件 -->
  <div class="search-box">
    <input class="search-txt" type="text" name="" placeholder="Type to serch">
    <i class="el-icon-search" href="#" id="search-btn"></i>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.search-box {
  position: absolute;
  background: #2f3640;
  height: 40px;
  border-radius: 40px;
  padding: 0px;
}
.search-box:hover > .search-txt {
  width: 240px;
  padding: 0 15px;
}
.search-box:hover > #search-btn {
  background: white;
}
#search-btn {
  color: #e84118;
  float:right;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #2f3640;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s;
  cursor: pointer;
}

.search-txt {
  border: none;
  background: none;
  outline: none;
  float: left;
  padding: 0;
  color: white;
  font-size: 16px;
  transition: 0.4s;
  line-height: 40px;
  width: 0px;
}
</style>